import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildDeadTree: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const centerX = 2;
    const centerZ = 2;

    brush.column(centerX, centerZ, 0, 6, BLOCK.Log);
    brush.lineX(0, 1, 4, centerZ, BLOCK.Log);
    brush.lineX(3, 4, 5, centerZ, BLOCK.Log);
    brush.lineZ(centerX, 5, 0, 1, BLOCK.Log);
    brush.block(centerX, 6, centerZ + 1, BLOCK.Log);
    brush.block(centerX - 1, 0, centerZ - 1, BLOCK.DeadBush);
    brush.block(centerX + 1, 0, centerZ + 1, BLOCK.DeadBush);
    brush.block(centerX + 2, 0, centerZ - 1, BLOCK.DeadBush);
};
